import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

function BlogPostDetail() {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch("/blog.json")
      .then((res) => res.json())
      .then((data) => {
        const foundPost = data.find(
          (p) => p.Id === parseInt(id)
        );
        setPost(foundPost);
      })
      .catch((err) => console.error("Error loading post:", err));
  }, [id]);

  if (!post) return <div style={{ padding: "40px" }}>Loading...</div>;

  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "auto" }}>
      <h1>{post.Title}</h1>
      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: post.Body }}
      />
    </div>
  );
}

export default BlogPostDetail;

